import script from "./FundingSummaryView.vue?vue&type=script&setup=true&lang=js"
export * from "./FundingSummaryView.vue?vue&type=script&setup=true&lang=js"

import "./FundingSummaryView.vue?vue&type=style&index=0&id=d881ab9e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d881ab9e"]])

export default __exports__